import { Link } from "wouter";
import { motion } from "framer-motion";

function Home() {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-gray-800 via-black to-black px-4">
      
      {/* Glow background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/4 left-1/4 h-64 w-64 rounded-full bg-orange-500/20 blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 h-48 w-48 rounded-full bg-orange-500/20 blur-2xl"></div>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mx-auto max-w-6xl text-center"
      >
        <h1 className="mb-6 text-3xl font-bold leading-tight text-white sm:text-4xl md:text-6xl lg:text-7xl">
          Accelerate Your{" "}
          <span className="text-orange-500">Digital Transformation</span>
          <br className="hidden sm:block" />
          with Real-Time Data Solutions
        </h1>

        <p className="mx-auto mb-10 max-w-3xl text-base text-gray-300 sm:text-lg md:text-xl">
          Harness the power of Apache Kafka, Flink, AI/ML, and modern cloud
          platforms to innovate faster and scale smarter.
        </p>

        {/* Buttons */}
        <div className="flex w-full flex-col items-center gap-4 sm:flex-row sm:justify-center">
  <a
    href="/services"
    className="w-full max-w-xs rounded-md bg-orange-500 px-6 py-3 text-center text-base font-semibold text-white transition hover:bg-orange-600 sm:w-auto sm:px-8 sm:py-4 sm:text-lg"
  >
    Explore Our Services
  </a>

  <a
    href="/contact"
    className="w-full max-w-xs rounded-md border-2 border-orange-500 px-6 py-3 text-center text-base font-semibold text-orange-500 transition hover:bg-orange-500 hover:text-white sm:w-auto sm:px-8 sm:py-4 sm:text-lg"
  >
    Contact Us
  </a>
</div>

      </motion.div>
    </section>
  );
}
export default Home;